import { Dispatch } from 'redux';

import { Events } from 'src/constants/webSocketConsts/events';
import { AppBuilder, appBuilderApi } from 'src/services/api/appBuilderApi';

export function handleAppBuilderUpdate(
  event: Events,
  items: AppBuilder[],
  dispatch: Dispatch<any>,
) {
  const builder = items.at(0);
  if (!builder) {
    return;
  }

  if (event === Events.Remove) {
    return;
  }

  if (event === Events.Modify || event === Events.Insert) {
    dispatch(
      appBuilderApi.util.updateQueryData(
        'getAppBuilder',
        { id: builder.id },
        (draft: AppBuilder) => {
          Object.assign(draft, builder);
        },
      ),
    );
  }
}
